import * as React from 'react';
const SvgStoryTelling = (props) => (
  <svg viewBox="0 0 124 117" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M53.208 40.743c7.757 0 12.711-1.238 14.705-2.434 1.243-.745 2.879-.357 3.648.847 1.205 1.892 3.852 4.404 10.036 4.196"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m38.774 81.355 13.549-3.871v-7.742c-2.41-2.192-5.807-3.871-7.742-11.613-.77-3.087-1.582-8.444-1.936-11.613-.406-3.643-.334-7.093 0-9.677C43.637 29.203 52.961 23.29 62 23.29s18.363 5.913 19.355 13.549c.334 2.584.406 6.034 0 9.677-.353 3.17-1.166 8.526-1.935 11.613-1.936 7.742-5.333 9.421-7.742 11.613v7.742l13.548 3.87M79.424 86.005l6.494 10.389M38.082 96.394l6.494-10.39M94.903 58.13h7.742M29.097 58.13h-7.742M18.926 42.311l6.793-14.816M98.28 27.495l6.794 14.816M32.968 21.355c5.345 0 9.677-4.333 9.677-9.678C42.645 6.333 38.313 2 32.968 2s-9.678 4.333-9.678 9.677c0 5.345 4.333 9.678 9.678 9.678ZM91.032 21.355c5.345 0 9.678-4.333 9.678-9.678C100.71 6.333 96.377 2 91.032 2c-5.344 0-9.677 4.333-9.677 9.677 0 5.345 4.333 9.678 9.677 9.678ZM112.322 67.806c5.345 0 9.678-4.332 9.678-9.677s-4.333-9.677-9.678-9.677c-5.344 0-9.677 4.332-9.677 9.677s4.333 9.678 9.677 9.678ZM11.677 67.806c5.345 0 9.678-4.332 9.678-9.677s-4.333-9.677-9.678-9.677C6.333 48.452 2 52.784 2 58.129s4.333 9.678 9.677 9.678ZM91.032 114.258c5.345 0 9.678-4.333 9.678-9.677 0-5.345-4.333-9.678-9.678-9.678-5.344 0-9.677 4.333-9.677 9.678 0 5.344 4.333 9.677 9.677 9.677ZM32.968 114.258c5.345 0 9.677-4.333 9.677-9.677 0-5.345-4.332-9.678-9.677-9.678s-9.678 4.333-9.678 9.678c0 5.344 4.333 9.677 9.678 9.677Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.42 43.705a32.756 32.756 0 0 0-3.323 14.424c0 18.174 14.729 32.903 32.903 32.903S94.903 76.303 94.903 58.13a32.763 32.763 0 0 0-3.373-14.52"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgStoryTelling;
